export default {
  news: state => state.news,
  highlightedNews: state => state.highlightedNews,
  mainNews: state => state.mainNews,
  newsInfos: state => state.newsInfos,
  totalPages: state => state.totalPages
}
